import React, { useState } from 'react';
import { getVideoThumbnailUrl, getYouTubeThumbnailUrl } from '../utils/video';

// Still image for a video post, tried in order until one loads:
//   1. `src` — the writer's own upload, when there is one
//   2. YouTube: the sharp 16:9 maxresdefault frame, then the always-present
//      hqdefault (maxres doesn't exist for every upload; YouTube answers
//      with a 120×90 placeholder, sometimes as a 404, sometimes as a 200)
//   3. Rumble: the thumbnail its oEmbed reported when the post was saved
// Renders nothing when every candidate failed, so the caller's dark frame
// (and play badge) shows instead of a broken image.
function VideoThumbnail({ video, src = '', alt = '', ...rest }) {
    const candidates = [];
    const addCandidate = (value) => {
        if (value && !candidates.includes(value)) {
            candidates.push(value);
        }
    };
    addCandidate(src);
    if (video?.provider === 'youtube' && video.id) {
        addCandidate(getYouTubeThumbnailUrl(video.id, 'maxresdefault'));
    }
    addCandidate(getVideoThumbnailUrl(video));

    // Failures are remembered per candidate list, so a new video (or a new
    // upload) starts from the top again without an effect.
    const candidateKey = candidates.join('|');
    const [failure, setFailure] = useState({ key: '', index: 0 });
    const index = failure.key === candidateKey ? failure.index : 0;
    const current = candidates[index];

    if (!current) {
        return null;
    }

    const skip = () => setFailure({ key: candidateKey, index: index + 1 });

    const handleLoad = (event) => {
        if (current.includes('/maxresdefault.') && event.currentTarget.naturalWidth <= 120) {
            skip();
        }
    };

    return (
        <img
            src={current}
            alt={alt}
            onLoad={handleLoad}
            onError={skip}
            {...rest}
        />
    );
}

export default VideoThumbnail;
